export default {
  model: {
    'adminUser': '管理员',
    'adminUsersRole': '管理员',
    'role': '角色',
    'banner': '轮播图',
    'user': '用户',
    'application': '应用管理',
    'activeStorage/blob': '资源',
    'actsAsTaggableOn/tag': '标签',
    'page': '页面',
    'presetPage': '页面',
    'staticPage': '页面',
    'customPage': '自定义页面',
    'company': '供应商',
    'factory': '加工厂',
    'rejectReason': '拒绝与逾期原因',
    'productCategory': '商品分类',
    'optionType': '规格',
    'product': '商品',
    'optionValue': '规格值',
    'order': '订单',
    'productDesign': '服装制单',
    'delivery': '出货',
    'cuttingRecord': '裁床记录',
    'variant': 'Variant',
    'variantCompanyRelation': 'Variant company relation',
    'material': '原材料',
    'warehouse': '仓库',
    'virtualWarehouse': '虚拟仓',
    'orderSnapshot': '订单修改提醒',
    'project': '项目',
    'orderAccessoryDelivery': 'Order accessory delivery',
    'notification': '通知',
    'profile': '个人信息',
    'lineItem': '订单项',
    'deliveryItem': '出货项',
    'cuttingItem': '裁床记录项',
    'productDesignItem': '制单项',
    'lineItemProcessingPlantRelation': 'Line item processing plant relation',
    'operationLog': '操作记录',
  },
  'adminUser': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    email: '邮箱',
    name: '姓名',
    userId: 'User',
    role: '角色',
    user: '用户',
  },
  'adminUsersRole': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    roleId: '角色',
    adminUserId: 'Admin user',
    applicationId: '应用ID',
    role: '角色',
    application: '应用管理',
    adminUser: '管理员',
  },
  'role': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    kind: '类型',
    kinds: {
      super: 'Super',
      application: '应用管理',
      designer: '设计师',
      merchandiser: '跟单员',
      salesman: 'Salesman',
      not_any: 'Not any',
      custom: 'Custom',
      sales_director: '销售主管',
      supplier: 'Supplier',
      supplier_boss: 'Supplier boss',
      cheif_pattern_making_officier: '版房总监',
      pattern_maker: '制版师',
      craftsman: '工艺师',
      quality_inspector: 'Quality inspector',
      plate_reviewer: 'Plate reviewer',
      purchaser: 'Purchaser',
      guest: 'Guest',
    },
    customPermissions: '自定义权限',
  },
  'banner': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    target: '目标',
    position: '优先级',
    pagePosition: '页面位置',
    pagePositions: {
      event: '事件',
    },
    kind: '类型',
    kinds: {
      web_link: '网站链接',
      image: '纯图片',
      mp_link: '小程序链接',
    },
    alt: '图片描述',
    image: '图片',
  },
  'user': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    isBlock: '已冻结',
    role: '角色',
    roles: {
      designer: '设计师',
      pattern_maker: '制版师',
      cheif_pattern_making_officier: '版房总监',
      merchandiser: '跟单员',
      salesman: '销售员',
      boss: 'BOSS',
      supplier: '供应商员工',
      application_admin_user: '总管理员',
      sales_director: '销售主管',
      supplier_boss: '供应商BOSS',
      craftsman: '工艺师',
      sewer: '车版师',
      valuer: '核价师',
      quality_inspector: '质检员',
      plate_reviewer: '审版员',
      purchaser: '采购员',
      guest: '游客',
    },
    companyId: '供应商ID',
    remark: '备注',
    screenName: '微信昵称',
    state: '审核状态',
    states: {
      init: '未提交',
      pending: '待处理',
      approved: '已通过',
      rejected: '已拒绝',
    },
    rejectReason: '拒绝原因',
    salesDirectorId: '销售主管',
    expiresAt: '账号过期时间',
    profile: '个人信息',
    updateProductCostPrice: '更新商品成本价',
    productOperator: 'Product operator',
    manageOtherProductDesign: '管理制单',
    manageOtherProductDesignFiles: '附件下载',
    readOtherProductDesignCost: '查看成本',
    readProductDesignStatistics: '查看制单统计数据',
    readOrderCost: '查看订单生产报价',
    readProductCostPrice: '查看商品成本价',
    readCompany: '查看供应商',
    readProductionOrders: '查看生产部订单',
    avatar: '头像',
    company: '供应商',
    adminUser: '管理员',
    salesDirector: '销售主管',
    patternFactory: '打版工厂',
    patternFactories: {
      pattern: '版房',
      cooperative_pattern: '合作版房',
      semi_finished_pattern: '半成品打版',
    },
    projectIds: '项目',
    projects: '项目',
  },
  'application': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    desc: '描述',
    shareDesc: '分享描述',
    shareTitle: '分享标题',
    wechatApplicationId: 'Wechat application',
    applicationAdminUsersRoleId: 'Application admin users role',
    shareImage: '分享图片',
    logo: 'Logo',
    creator: '发起人',
    posterImage: '海报图片',
  },
  'activeStorage/blob': {
    url: '内容',
    signedId: 'Signed',
    contentType: '类型',
    filename: '文件名',
    byteSize: 'Byte size',
    id: 'ID',
    createdAt: '创建时间',
  },
  'actsAsTaggableOn/tag': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
  },
  'page': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    slug: 'Slug',
    title: '标题',
    type: '类型',
    applicationId: '应用ID',
    status: '状态',
    statuses: {
      draft: '草稿',
      published: '发布',
    },
    viewsCount: '浏览数',
    miniProgramPath: '小程序路径',
    wxacode: '小程序码',
    content: '内容',
  },
  'presetPage': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    slug: 'Slug',
    viewsCount: '浏览数',
    content: '内容',
  },
  'staticPage': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    slug: 'Slug',
    status: '状态',
    statuses: {
      draft: '草稿',
      published: '发布',
    },
    viewsCount: '浏览数',
    wxacode: '小程序码',
    content: '内容',
  },
  'customPage': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    slug: 'Slug',
    default: '预置页面',
    miniProgramPath: '小程序路径',
    formalCustomPageId: 'Formal custom page',
    canRollbackData: 'Can rollback data',
    configs: '自定义页面',
  },
  'company': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    jushuitanSupplierId: '聚水潭供应商ID',
    orderLimit: '订单总件数',
    orderUsageRate: '产能饱和率(%)',
    onTheWayOrdersCount: '在途订单数',
    onTheWayOrdersCost: '在途订单总金额',
    overdueRate: '逾期率(%)',
    liquidatedDamages: '违约费',
    returnRate: '退货率(%)',
    currentMonthRating: '月度评级',
    currentQuarterRating: '季度评级',
    currentYearRating: '年度评级',
    merchandiserIds: '跟单员',
    merchandisers: '跟单员',
  },
  'factory': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    companyId: '供应商ID',
    company: '供应商',
  },
  'rejectReason': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    reason: '原因',
    kind: '类型',
    kinds: {
      admin_reject_apply: '管理员拒绝用户申请',
      cheif_pattern_making_officier_reject_product_design: '版房总监拒绝服装制单',
      merchandiser_reject_order: '跟单员拒绝订单',
      boss_reject_order: 'BOSS拒绝订单',
      product_design_overdue: '服装制单逾期',
      order_overdue: '订单逾期',
      sales_director_reject_order: '销售主管拒绝订单',
      supplier_reject_order: '供应商拒绝订单',
      sales_director_reject_product_design: '销售主管拒绝服装制单',
      supplier_reject_product_design: '供应商员工拒绝服装制单',
      supplier_boss_reject_product_design: '供应商BOSS拒绝服装制单',
      reject_product_design_make_plate: '拒绝服装制单制版',
      reject_product_design_cut: '拒绝服装制单剪版',
      reject_product_design_sew: '拒绝服装制单车版',
      admin_reject_order: '总管理员拒绝订单',
      accessory_reject_order: '拒收辅料',
      reject_product_design_craft: '拒绝服装制单工艺',
    },
  },
  'productCategory': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    includeAccessory: '包含辅料',
    skipInbound: '跳过入库',
    kind: '类型',
    kinds: {
      other: 'Other',
      customized: 'Customized',
    },
  },
  'optionType': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    kind: '类型',
    kinds: {
      color: '颜色',
      size: '尺寸',
    },
    optionValues: '规格值',
    optionValuesAttributes: '规格值',
  },
  'product': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    styleNumber: '款号',
    semiStyleNumber: '半成品款号',
    number: '版单号',
    colorNumber: '色号',
    productCategoryId: 'Product category',
    creatorId: 'Creator',
    supplierName: '供应商名称',
    vcName: '虚拟分类',
    salesPrice: '销售价格',
    costPrice: '成本价',
    returnPeriod: '返单周期（天）',
    releaseAt: '上新日期',
    minOrderQty: '单色最低起订量',
    fabricCuttingCount: '一条面料裁床数',
    image: '图片',
    productCategory: '商品分类',
    creator: '创建人',
    sizeOptionValues: '尺寸',
    colorOptionValues: '颜色',
    variants: 'SKU',
    productDesign: '服装制单',
    productDesignPaperPatternFiles: 'Product design paper pattern files',
    productDesignCostDetailFiles: 'Product design cost detail files',
    sizeOptionValueIds: 'Size option value ids',
    colorOptionValueIds: 'Color option value ids',
    colorOptionValueList: 'Color option value list',
    productDesignCostPrice: 'Product design cost price',
    productDesignSettlementCost: 'Product design settlement cost',
  },
  'optionValue': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    optionTypeId: 'Option type',
    position: '优先级',
    optionType: '规格',
  },
  'order': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    number: '订单号',
    overdueReason: '逾期原因',
    rejectReason: '拒绝原因',
    remark: '备注',
    internalRemark: '内部备注',
    companyId: '供应商ID',
    creatorId: 'Creator',
    merchandiserId: 'Merchandiser',
    productId: 'Product',
    quantity: '数量',
    state: '状态',
    states: {
      init: '草稿',
      pending: '待跟单员审核',
      rejected: '跟单员已拒绝',
      wait_admin_audit: '待总管理员审核',
      admin_rejected: '总管理员已拒绝',
      wait_boss_audit: '待老板审核',
      boss_rejected: '老板已拒绝',
      wait_supplier_confirm: '待供应商员工确认',
      confirmed: '供货商员工已确认',
      partial: '部分完成',
      completed: '已完成',
      wait_sales_director_audit: '待销售主管审核',
      wait_supplier_boss_confirm: '待供应商BOSS确认',
      sales_director_rejected: '销售主管已拒绝',
      supplier_boss_rejected: '供应商BOSS已拒绝',
      supplier_rejected: '供应商员工已拒绝',
      fabric_arrived: '面料到位',
      cutting_updated: '裁床已更新',
      printing_in_progress: '印绣花进行中',
      workshop_in_progress: '车间进行中',
      tail_in_progress: '尾部进行中',
    },
    deliveryOn: '交货日期',
    deliveryRemark: '出货备注',
    planCompletedOn: '计划完成日期',
    auditedAt: '审核时间',
    completedAt: '完成时间',
    confirmedAt: '确认时间',
    orderAt: '下单时间',
    receiveClothOn: '布料到位',
    receiveClothRemark: '布料到位备注',
    printingStartOn: '印绣花进行中',
    printingRemark: '印绣花备注',
    workshopStartOn: '车间进行中',
    workshopRemark: '车间备注',
    tailStartOn: '尾部时间进行中',
    tailRemark: '尾部时间备注',
    overdueState: '逾期状态',
    supplierId: 'Supplier',
    supplierRemark: '供应商备注',
    factoryId: '加工厂',
    factoryRemark: '工厂备注',
    isPushToJushuitan: 'Is push to jushuitan',
    supplierFirstRejectReason: '供应商员工首次拒绝原因',
    supplierBossFirstRejectReason: '供应商BOSS首次拒绝原因',
    virtualWarehouseId: 'Virtual warehouse',
    liquidatedDamages: '违约金',
    accessoryState: '辅料状态',
    accessoryStates: {
      needless: '无需辅料',
      pending: '待提交辅料',
      submited: '待接收辅料',
      received: '已签收辅料',
      rejected: '拒收辅料',
      confirmed: '已接收辅料',
      need: 'Need',
    },
    needAccessory: '需要辅料',
    fabricCost: '面料成本',
    craftCost: '工艺费用',
    processingCost: '加工费',
    assistCost: '辅料成本',
    managementCost: '风险控制成本',
    costPrice: '生产报价',
    accessoryReachOn: '车间辅料到达日期',
    isPreOrder: '预下单',
    watch: '关注',
    company: '供应商',
    creator: '销售员',
    salesDirector: '销售主管',
    merchandiser: '跟单员',
    product: '商品',
    lineItems: '订单项',
    supplier: '供应商员工',
    factory: '加工厂',
    purchaseOrder: 'Purchase order',
    virtualWarehouse: '虚拟仓',
    deliveries: '出货',
    preProductionMeetingMinutes: '产前会议记录',
    customerLevel: '客户等级',
    customerLevels: {
      s: 'S级',
      a: 'A级',
      b: 'B级',
    },
    qualityRequirement: '品质要求',
    qualityRequirements: {
      customized: '定制品质',
      brand: '品牌品质',
    },
    totalProductCost: '订单金额',
    cuttingRecords: '裁床记录',
    lineItemsAttributes: '订单项',
    orderCuttingDates: '裁床更新',
    orderCuttingRemark: '裁床备注',
    stateOperationLogs: 'State operation logs',
    accessoryStateOperationLogs: 'Accessory state operation logs',
    files: '附件',
    orderAccessoryDeliveries: 'Order accessory deliveries',
    merchandiserInspectionRemark: '跟单查货质检备注',
    merchandiserInspectionRemarkImages: '跟单查货质检备注图片',
    preProductionMeetingImages: '产前会议图片',
  },
  'productDesign': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    number: '版单号',
    overdueReason: '逾期原因',
    rejectReason: '拒绝原因',
    remark: '备注',
    cheifPatternMakingOfficierId: 'Cheif pattern making officier',
    designType: '设计稿类型',
    designTypes: {
      custom: '定制',
      men: '男装',
      women: '女装',
    },
    designerId: 'Designer',
    patternMakerId: 'Pattern maker',
    state: '状态',
    states: {
      init: '草稿',
      pending: '待版房总监审核',
      wait_confirm: '待制版师确认',
      making: '制作中',
      completed: '已完成',
      rejected: '版房总监已拒绝',
      wait_sales_director_audit: '待销售主管审核',
      sales_director_rejected: '销售主管已拒绝',
      receive_fabric_and_assist_confirmed: '面、辅料已确认',
      making_plate: '制版中',
      make_plate_completed: '纸板完成',
      make_plate_rejected: '拒绝制版',
      cutting: '剪版中',
      crafting: '工艺进行中',
      craft_completed: '工艺完成',
      cut_rejected: '拒绝剪版',
      sewing: '车版中',
      sew_completed: '车版完成',
      sew_rejected: '拒绝车版',
      quantity_audited: '已成本核价',
      wait_confirm_craft: '待确认工艺',
      craft_rejected: '拒绝工艺',
      wait_confirm_make_plate: '待确认制版',
      plate_approved: '审版通过',
      signed_sample: '样版已签收',
      wait_audit_quantity: '待成本核价',
    },
    publicationOn: '要求出版日期',
    salesDirectorAuditedAt: '销售主管审核时间',
    auditedAt: '版房总监审核时间',
    completedAt: '完成时间',
    confirmedAt: '确认时间',
    planCompletedOn: '计划完成日期',
    companyId: '供应商',
    supplierId: 'Supplier',
    patternFactory: '打版工厂',
    patternFactories: {
      pattern: '版房',
      cooperative_pattern: '合作版房',
      semi_finished_pattern: '半成品打版',
    },
    receivePatternOn: '纸样日期',
    receivePatternRemark: '纸样备注',
    receiveFabricAndAssistOn: '辅料到位日期',
    processStartOn: '工艺进行中日期',
    sewingStartOn: '车缝进行中日期',
    completedRemark: '完成备注',
    planCompletedRemark: '计划完成备注',
    patternType: '版型',
    fabricCost: '面料成本',
    craftCost: '工艺费用',
    processingCost: '加工费',
    assistCost: '辅料成本',
    managementCost: '风险控制成本',
    fobProfit: 'FOB利润',
    managementFee: '管理费',
    inspectionFee: '件查费',
    costPrice: '样板总成本',
    fabricSettlementCost: '结算面料成本',
    craftSettlementCost: '结算工艺费用',
    processingSettlementCost: '结算加工费',
    assistSettlementCost: '结算辅料成本',
    managementSettlementCost: '结算风险控制成本',
    settlementCost: '结算总成本',
    overdueState: '逾期状态',
    plateMakingType: '打版类型',
    plateMakingTypes: {
      original: '初版',
      reproduction: '复版',
      pre_production: '产前版',
      fabric_craft: '布片工艺',
      paper_pattern: '纸样',
      pre_quotation: '预报价',
    },
    accessoryState: '辅料状态',
    accessoryStates: {
      unknown: '未知',
      needless: '无需辅料',
      pending: '待确认辅料',
      confirmed: '辅料已确认',
      completed: '辅料已完成',
    },
    fabricComplated: '面料完成',
    accessoryComplated: '辅料完成',
    purchaserId: 'Purchaser',
    customerName: '客户名称',
    fabricState: '面料状态',
    fabricStates: {
      unknown: '未知',
      needless: '无需面料',
      pending: '待确认面料',
      confirmed: '面料已确认',
      completed: '面料已完成',
    },
    fabricPurchaserId: 'Fabric purchaser',
    receiveFabricOn: '面料到位日期',
    mainImage: '主图',
    patternMaker: '制版师',
    company: '供应商',
    supplier: '供应商版房总监',
    cheifPatternMakingOfficier: '版房总监',
    designer: '设计师/销售员',
    purchaser: '辅料采购员',
    productDesignItemTableAttributes: 'Product design item table attributes',
    confirmAccessoryRemark: '辅料确认备注',
    confirmAccessoryRemarkImages: '辅料确认备注图片',
    confirmFabricRemark: '面料确认备注',
    confirmFabricRemarkImages: '面料确认备注图片',
    receiveFabricRemark: '面料到位备注',
    receiveFabricRemarkImages: '面料到位备注图片',
    fabricPurchaser: '面料采购员',
    receiveFabricAndAssistRemark: '辅料到位备注',
    receiveFabricAndAssistRemarkImages: '辅料到位备注图片',
    cheifPatternMakingOfficierRemark: '版房总监备注',
    paperPatternFiles: '纸样',
    costDetailFiles: '成本明细表',
    canSalesDirectorApprove: 'Can sales director approve',
    canSalesDirectorReject: 'Can sales director reject',
    canSalesDirectorWithdraw: 'Can sales director withdraw',
    canReject: 'Can reject',
    canComplete: 'Can complete',
    canRejectMakePlate: 'Can reject make plate',
    canMakePlate: 'Can make plate',
    canCompleteMakePlate: 'Can complete make plate',
    canCut: 'Can cut',
    canRejectCut: 'Can reject cut',
    canCraft: 'Can craft',
    canCompleteCraft: 'Can complete craft',
    canSew: 'Can sew',
    canRejectSew: 'Can reject sew',
    canCompleteSew: 'Can complete sew',
    canAuditQuantity: 'Can audit quantity',
    makePlateRemark: '制版中备注',
    makePlateRemarkImages: '制版中备注图片',
    canUpdateMakePlateRemark: 'Can update make plate remark',
    completeMakePlateRemark: '纸板完成备注',
    completeMakePlateRemarkImages: '纸板完成备注',
    canUpdateCompleteMakePlateRemark: 'Can update complete make plate remark',
    cutRemark: '剪版中备注',
    cutRemarkImages: '剪版中备注图片',
    canUpdateCutRemark: 'Can update cut remark',
    processRemark: '工艺进行中备注',
    processRemarkImages: '工艺进行中注备注图片',
    canUpdateProcessRemark: 'Can update process remark',
    completeCraftRemark: '工艺完成备注',
    completeCraftRemarkImages: '工艺完成备注图片',
    canUpdateCompleteCraftRemark: 'Can update complete craft remark',
    sewingRemark: '车缝进行中备注',
    sewingRemarkImages: '车缝进行中备注图片',
    canUpdateSewingRemark: 'Can update sewing remark',
    completeSewingRemark: '车版完成备注',
    completeSewingRemarkImages: '车版完成备注图片',
    canUpdateCompleteSewingRemark: 'Can update complete sewing remark',
    approvePlateRemark: '审版通过备注',
    approvePlateRemarkImages: '审版通过备注图片',
    canUpdateApprovePlateRemark: 'Can update approve plate remark',
    auditQuantityRemark: '成本核价备注',
    canUpdateAuditQuantityRemark: 'Can update audit quantity remark',
    images: '制单',
    files: '附件',
    craftsman: '工艺师',
    sewer: '车版师',
    valuer: '核价师',
    operationLogs: 'Operation logs',
    stateOperationLogs: 'State operation logs',
    accessoryStateOperationLogs: 'Accessory state operation logs',
    fabricStateOperationLogs: 'Fabric state operation logs',
    normalOperationLogs: 'Normal operation logs',
    ordersLatestAiFileUrl: 'Orders latest ai file url',
  },
  'delivery': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    orderId: 'Order',
    deliveryAt: '出货时间',
    state: '状态',
    states: {
      init: 'Init',
      delivering: '送货中',
      reached: '待质检',
      checked: '待点数入库',
      inbounded: '已入库',
      failed: '退厂返工',
      delivered: '已出货',
    },
    reachOn: '到货日期',
    checkOn: '查货日期',
    standardDeliveryForm: '有无纸质出货单',
    brokenOuterPackage: '外包装是否有破损',
    samplingRate: '抽检比例（%）',
    qualityComment: '质检情况',
    deliveryQuantity: '送货数量',
    hasOriginal: '有原版',
    defectiveQuantity: '次品数量',
    remark: '备注',
    checkImages: '图片',
    deliveryItems: '出货项',
    deliveryItemsAttributes: '出货项',
    operationLogs: 'Operation logs',
  },
  'cuttingRecord': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    orderId: 'Order',
    cuttingAt: '裁床更新时间',
    cuttingItems: '裁床记录项',
  },
  'variant': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    productId: 'Product',
    sku: 'SKU',
    colorOptionValueId: 'Color option value',
    sizeOptionValueId: 'Size option value',
    minOrderQty: '单色最低起订量',
    manufactureFlowIds: 'Manufacture flow ids',
    manufactureFlows: 'Manufacture flows',
    colorOptionValue: '颜色',
    sizeOptionValue: '尺寸',
    variantCompanyRelations: 'Variant company relations',
  },
  'variantCompanyRelation': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    companyId: '供应商ID',
    cost: '成本',
    processingCost: '加工费',
    company: '供应商',
    variantColorOptionValueId: 'Variant color option value',
    variantSizeOptionValueId: 'Variant size option value',
  },
  'material': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    sku: 'SKU',
  },
  'warehouse': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    jushuitanId: '聚水潭ID',
    virtual: 'Virtual',
  },
  'virtualWarehouse': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    jushuitanId: '聚水潭ID',
    disabled: '已作废',
  },
  'orderSnapshot': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    orderId: 'Order',
    readed: '是否已读',
    order: '订单',
    changesProductImage: 'Changes product image',
    changesContent: 'Changes content',
  },
  'project': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    userIds: 'User ids',
    users: '成员',
  },
  'orderAccessoryDelivery': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    orderId: 'Order',
    state: '状态',
    states: {
      pending: '待提交',
      submited: '待接收',
      received: '已签收',
      rejected: '拒收',
      confirmed: '已接收',
    },
    number: '编号',
    accessories: 'Accessories',
    orderAccessoryDeliveryItems: '辅料项',
    operationLogs: 'Operation logs',
    order: '订单',
  },
  'notification': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    event: 'Event',
    targetType: 'Target type',
    targetId: 'Target',
    isRead: '是否已读',
    title: '标题',
    content: '内容',
  },
  'profile': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '姓名',
    phone: '手机号码',
  },
  'lineItem': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    colorOptionValueId: 'Color option value',
    completeQuantity: '实际出货量',
    cuttingQuantity: '裁床数',
    orderId: 'Order',
    quantity: '数量',
    sizeOptionValueId: 'Size option value',
    sku: 'SKU',
    colorOptionValue: '颜色',
    sizeOptionValue: '尺寸',
  },
  'deliveryItem': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    deliveryId: 'Delivery',
    lineItemId: 'Line item',
    quantity: '数量',
    lineItem: '订单项',
  },
  'cuttingItem': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    cuttingRecordId: 'Cutting record',
    lineItemId: 'Line item',
    quantity: '数量',
    lineItem: '订单项',
  },
  'productDesignItem': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    quantity: '数量',
    colorOptionValueId: '颜色',
    sizeOptionValueId: '尺寸',
    colorOptionValue: '颜色',
    sizeOptionValue: '尺寸',
    color: 'Color',
  },
  'lineItemProcessingPlantRelation': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    processingPlantId: 'Processing plant',
    lineItemId: 'Line item',
    processingCost: '加工费',
    processingPlant: '加工厂',
  },
  'operationLog': {
    id: 'ID',
    createdAt: '操作时间',
    updatedAt: '更新时间',
    event: 'Event',
    eventDescription: '事件',
    detail: '详情',
    operatorId: 'Operator',
    operatorType: 'Operator type',
    timeConsuming: '耗时（秒）',
    operator: '操作人',
  },
}
